export default "__VITE_ASSET__c9e497fc__"